import { useTranslation } from 'react-i18next';
import { Button, Flex } from 'antd';
import { IssuesCloseOutlined } from '@ant-design/icons';
import { useGetCargoTrips } from 'api/trips/use-get-cargo-trips';
import { ColorsDropdown } from 'components/favorites/colors-dropdown';
import type { IAddFavoriteButtonProps } from './types';

export const AddFavoriteButton: React.FC<IAddFavoriteButtonProps> = (props) => {
  const { tripId } = props;
  const { t } = useTranslation();
  const { data: cargoTrips, isLoading } = useGetCargoTrips(tripId);

  if (!cargoTrips?.length) return null;

  const cargoIds = cargoTrips?.map((cargo) => cargo.cargoId) || [];

  return (
    <Flex gap='small' align='center' justify='flex-end'>
      <ColorsDropdown cargoIds={cargoIds}>
        <Button type='primary' icon={<IssuesCloseOutlined />} disabled={isLoading}>
          {t('favorite:mark_all_cargos_as_favorite')}
        </Button>
      </ColorsDropdown>
    </Flex>
  );
};
